import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=23c8d400&scoped=true&"
import script from "./BackButton.vue?vue&type=script&lang=ts&"
export * from "./BackButton.vue?vue&type=script&lang=ts&"
import style0 from "./BackButton.vue?vue&type=style&index=0&id=23c8d400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c8d400",
  null
  
)

export default component.exports